<template>
    <base-box v-bind="$props" padding="none" border-radius="large" v-on="$listeners">
        <template #content>
            <g-media-object vertical-align="center" class="brand-asset-container">
                <template #left>
                    <div class="brand-asset-image-container">
                        <img v-if="isImage" :src="asset.url" alt="asset" class="brand-asset-image" />
                        <g-icon v-else :name="iconName" size="emptyState" />
                    </div>
                </template>
                <div class="brand-asset-info">
                    <div>
                        <g-icon v-if="isImage" name="image" />
                        <g-typography tag="span" color="info" :value="fileDisplayName" />
                    </div>
                    <div>
                        <a :href="asset.url" target="_blank">{{ asset.name }}</a>
                    </div>
                </div>
            </g-media-object>
        </template>
    </base-box>
</template>

<script>
    import BaseBox from './BaseBox';
    import FILE_ICON_NAMES from '../../constants/file-icon-names';
    import { IMAGE_MIME_TYPES } from '../../constants/file-mime-types';
    import FILE_DISPLAY_NAMES from '../../constants/file-display-names';

    export default {
        /**
         * Component name
         *
         * @type {String}
         */
        name: 'BrandAsset',

        /**
         * Parent component
         *
         * @type {Object}
         */
        extends: BaseBox,

        /**
         * Child components
         *
         * @type {Object}
         */
        components: {
            BaseBox
        },

        /**
         * Component properties
         *
         * @type {Object}
         */
        props: {
            /**
             * Asset object
             */
            asset: {
                type: Object,
                required: true
            }
        },

        /**
         * Component computed properties
         *
         * @type {Object}
         */
        computed: {
            isImage() {
                return IMAGE_MIME_TYPES.includes(this.asset.mime);
            },

            fileDisplayName() {
                if (FILE_DISPLAY_NAMES.hasOwnProperty(this.asset.mime)) {
                    return FILE_DISPLAY_NAMES[this.asset.mime];
                }

                return 'File';
            },

            iconName() {
                if (FILE_ICON_NAMES.hasOwnProperty(this.asset.mime)) {
                    return FILE_ICON_NAMES[this.asset.mime];
                }

                return 'file';
            }
        }
    };
</script>

<style lang="scss" scoped>
    .brand-asset-container {
        max-height: 76px;
    }

    .brand-asset-image-container {
        width: 72px;
    }

    .brand-asset-image {
        max-width: 72px;
        height: auto;
        max-height: 72px;
    }

    .brand-asset-info {
        padding: $g-spacing-3;
    }

    .brand-asset-info div {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        min-width: 0;
        max-width: 250px;
    }
</style>
